<template>
  <article class="example-page">
    <h1>Switch</h1>
    <form>
      <label for="id">ID</label>
      <input id="id" v-model="idData" type="text" placeholder="ID">
      <label for="label">Label</label>
      <input id="label" v-model="labelData" type="text" placeholder="Label">
      <label for="rightAligned">Is Right Aligned</label>
      <input id="rightAligned" v-model="isRightAlignedData" type="checkbox">
    </form>

    <toggle-switch
      :id="idData"
      :label="labelData"
      :is-right-aligned="isRightAlignedData"
      class="toggle-switch"
      @checked="addEvent('checked')"
      @unchecked="addEvent('unchecked')"
    />

    <div class="received-event">{{ receivedEventData }}</div>
  </article>
</template>

<script>
import { toggleSwitch } from '@/components/layout';

export default {
  components: { 'toggle-switch': toggleSwitch },
  data() {
    return {
      idData: 'switch-id',
      labelData: 'Switch Label',
      isRightAlignedData: false,
      receivedEventData: '',
    };
  },
  methods: {
    addEvent(eventType) {
      this.receivedEventData = eventType;
    },
  },
};
</script>

<style lang="scss" scoped>


  .toggle-switch {
    margin-top: 1rem;
  }

  .received-event {
    margin-top: 1.375rem;
    padding: 0.625rem 1.375rem;
    border: 1px solid $black;
    width: fit-content;

    &:empty {
      display: none;
    }
  }
</style>
